import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

const RouterPrompt = props => {
  const { when, onRequestConfirm, onRequestCancel, user, heading } = props;

  const history = useHistory();

  const [showPrompt, setShowPrompt] = useState(false);
  const [currentPath, setCurrentPath] = useState('');
  const [lastPathname, setLastPathname] = useState(window.location.pathname);

  useEffect(() => {
    const handlePopState = event => {
      event.preventDefault();
      window.history.pushState(null, '', lastPathname);
    };

    const resetState = () => {
      history.block(() => {});
      window.removeEventListener('popstate', handlePopState);
    };

    if (when) {
      history.block(prompt => {
        if (prompt.pathname !== '/homePage') {
          setCurrentPath(prompt.pathname);
          setShowPrompt(true);
          return 'true';
        }
      });
      window.addEventListener('popstate', handlePopState);
    } else resetState();

    return () => resetState();
  }, [history, when, lastPathname]);

  const handleRequestConfirm = useCallback(async () => {
    if (onRequestConfirm) {
      await Promise.resolve(onRequestConfirm());
      if (currentPath && currentPath !== '/ingestion/connectors') {
        history.block(() => {});
        history.push(currentPath);
        setLastPathname(currentPath);
      }
    }
  }, [currentPath, history, onRequestConfirm]);

  const handleRequestCancel = useCallback(async () => {
    if (onRequestCancel) {
      const canRoute = await Promise.resolve(onRequestCancel());
      if (canRoute) {
        history.block(() => {});
        history.push(currentPath);
      }
    }
    setShowPrompt(false);
  }, [currentPath, history, onRequestCancel]);

  return (
    <Dialog
      id="discard-changes"
      open={showPrompt}
      onClose={(_, reason) => {
        if (reason === 'backdropClick') return;
        handleRequestCancel();
      }}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth>
      <DialogTitle>{heading}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          A360
        </Typography>
        <Typography paragraph>Hey {user?.first_name},</Typography>
        <Typography paragraph>
          All the changes you have made in this form will be discarded.
        </Typography>
        <Typography paragraph>Are you sure you want to cancel?</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleRequestCancel}>Cancel</Button>
        <Button variant="contained" onClick={handleRequestConfirm}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RouterPrompt;
